import React, {  Component } from 'react';

export default class NoDuplicateFromBackOrdersOverlayDialog extends Component {

    constructor(props) {
        super(props);
        this.state = {
            showDialog: false
        }
    }

    closeDialog(event) {
        event.preventDefault();
        this.setState({
            showDialog: false
        });
		this.props.handleDialog && this.props.handleDialog('NoDuplicateFromBackOrdersOverlayDialog', false);
    }

    componentDidMount() {
		// window.scrollTo(0, 0);
        this.setState({
            showDialog: this.props.showDialog
        });
    }

    render() {
        const self = this;
        const { duplicateItems } = self.props;
        return (
            <div className={"overlayDialog "+(this.state.showDialog?"visible":"hide")} id="actionDescriptionsOverlayDialog">
                <div className="blackoutLayer"></div>
                <div className="overlayDialogWindow">
                    <a className="closeButton" onClick={this.closeDialog.bind(this)}>×</a>
                    <h2 className="title">Duplicate Items</h2>
					{duplicateItems && duplicateItems.map((item, index) => {
                        return <p key={index}>
                            Your order contains duplicate backorders for {item.item} from order {item.originalOrderNumber}. Please delete one to proceed.
                        </p>
                    })}
                    <div className="yesButtonContainer">
                        <a className="yesButton blueButton" onClick={this.closeDialog.bind(this)}>Ok</a>
                    </div>
            	</div>
			</div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/App/components/dialogs/noDuplicateFromBackOrdersOverlayDialog.js